import { useSyncExternalStore } from 'react';
import { getState, subscribe, setState } from '../state/store.js';

/**
 * Custom React hook subscribing to the central in-memory store.
 * Guarantees zero-tear, synchronous updates without DOM-state desync.
 * 
 * @template T
 * @param {(state: import('../types/index.js').AppState) => T} [selector]
 * @returns {T}
 */
export function useStore(selector = (s) => s) {
  return useSyncExternalStore(
    subscribe,
    () => selector(getState()),
    () => selector(getState())
  );
}

export { getState, setState };
